import { useMemo } from 'react';
import { SupportedLocales } from '@/models/localization.model';
import { IProduct } from '@/models/products.model';
import { TProductLocalizedFields, TProductMainInfoFormValues } from '../helpers';
import { photoToPhotoItem } from '../helpers';

export const useTransformedProductInitialValues = (
  initialValues?: IProduct | null,
): TProductMainInfoFormValues | null => {
  const transformedInitialValues = useMemo(
    () =>
      initialValues
        ? {
            ...initialValues,
            field_sources: initialValues.field_sources ?? null,
            uktzed: initialValues.uktzed.toString(),
            photos: [...initialValues.photos]
              .sort((a, b) => a.order - b.order)
              .map((photo) => photoToPhotoItem(photo, photo.order)),
            unit_code: initialValues?.unit_code,
            package_quantity: initialValues?.package_quantity ?? 1,
            min_order_packages: initialValues?.min_order_packages ?? 1,
            locale: initialValues.locale.reduce((acc: { [key in SupportedLocales]: TProductLocalizedFields }, item) => {
              acc[item.locale] = { name: item.name, description: item.description, original_name: item.original_name };
              return acc;
            }, {} as { [key in SupportedLocales]: TProductLocalizedFields }),
          }
        : null,
    [initialValues],
  );

  return transformedInitialValues;
};
